import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0b37738"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-flex-column" }
const _hoisted_2 = { class: "p-col-12 p-d-flex" }
const _hoisted_3 = { class: "channels-info" }
const _hoisted_4 = { class: "campaign-list-counters w-100 p-d-flex p-flex-sm-wrap p-flex-lg-nowrap" }
const _hoisted_5 = { class: "p-mt-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Content", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfluencerInformation = _resolveComponent("InfluencerInformation")!
  const _component_CampaignsCounterItem = _resolveComponent("CampaignsCounterItem")!
  const _component_CampaignsCounterItemSwitch = _resolveComponent("CampaignsCounterItemSwitch")!
  const _component_ContentItemsList = _resolveComponent("ContentItemsList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
    }, "⟵ Influencer Stats"),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InfluencerInformation, {
        "channel-data": _ctx.currentWorker,
        "channel-stats": _ctx.currentChannelMetrics,
        campaign: _ctx.currentCampaign,
        "is-channel": true,
        class: "p-mr-4"
      }, null, 8, ["channel-data", "channel-stats", "campaign"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, "Campaign #LNA" + _toDisplayString(_ctx.currentCampaign?.id), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CampaignsCounterItem, {
            name: 'Total conversions',
            counter: _ctx.currentChannelMetrics?.conversions?.toString() || '0'
          }, null, 8, ["counter"]),
          _createVNode(_component_CampaignsCounterItem, {
            name: 'Total Clicks',
            counter: _ctx.currentChannelMetrics?.clicks?.toString() || '0'
          }, null, 8, ["counter"]),
          _createVNode(_component_CampaignsCounterItemSwitch, {
            ios: _ctx.currentChannelMetrics?.IOS,
            android: _ctx.currentChannelMetrics?.android || '0'
          }, null, 8, ["ios", "android"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_ContentItemsList, { items: _ctx.currentChannelContent }, null, 8, ["items"])
    ])
  ]))
}